<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <v-container v-else class="Kanit" style="padding-bottom: 70px">
      <div style="text-align: center" class="py-2 mb-3">
        <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
      </div>
      <h2 style="color: #0c4d9d" class="mb-4">เรียกรถส่งของ</h2>
      <ValidationObserver ref="observer" tag="form">
        <form>
          <ValidationProvider
            name="เวลา"
            :rules="{
              required: true,
            }"
            v-slot="{ errors }"
          >
            <v-select
              :items="timeoptions"
              v-model="input.time"
              :error-messages="errors"
              outlined
              placeholder="เวลา"
            ></v-select>
          </ValidationProvider>

          <div style="clear: both"></div>

          <ValidationProvider
            :rules="{
              required: true,
            }"
            :name="'ชื่อร้าน'"
            key="ชื่อร้าน"
            v-slot="{ errors }"
          >
            <v-text-field
              @input="input.shipper_name = removeHiddenSpace($event)"
              v-model="input.shipper_name"
              outlined
              placeholder="ชื่อร้าน"
              class="mb-6"
              :error-messages="errors"
              :hide-details="errors.length == 0"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider
            :rules="{
              required: true,
            }"
            :name="'เบอร์โทรร้าน'"
            key="เบอร์โทรร้าน"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="input.shipper_phoneno"
              outlined
              placeholder="เบอร์โทรร้าน"
              class="mb-6"
              type="number"
              :error-messages="errors"
              :hide-details="errors.length == 0"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider
            :rules="{
              required: selectedOrders && selectedOrders.length ? false : true,
            }"
            :name="'จำนวน'"
            key="จำนวน"
            v-slot="{ errors }"
          >
            <v-text-field
              :disabled="selectedOrders && selectedOrders.length ? true : false"
              v-model="input.quantity"
              outlined
              placeholder="จำนวน"
              class="mb-6"
              type="number"
              :error-messages="errors"
              :hide-details="errors.length == 0"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider
            :name="'หมายเหตุ'"
            key="หมายเหตุ"
            v-slot="{ errors }"
          >
            <v-textarea
              v-model="input.remark"
              outlined
              rows="3"
              placeholder="หมายเหตุ"
              class="mb-6"
              :error-messages="errors"
              :hide-details="errors.length == 0"
            ></v-textarea>
          </ValidationProvider>
        </form>
        <div>
          <div>
            <div style="color: red" class="text-center mb-3">
              *กรุณาเลือกออเดอร์ที่ต้องการจัดส่ง
            </div>
            <div class="px-6">
              <v-card
                v-for="(item, k) in orders"
                :key="k"
                elevation="0"
                style="border: 0.5px solid #e0e0e0 !important"
                class="mb-3 py-1"
              >
                <v-card-text style="line-height: 20px">
                  <div style="display: flex; justify-content: space-between">
                    <div>
                      <div style="font-weight: 900; color: black">
                        Order : #{{ item.ordernumber }} ลูกค้า
                        {{ item.customer_name }}
                      </div>
                      <div
                        style="
                          font-weight: bold;
                          font-size: small;
                          color: #0c4d9d;
                        "
                      >
                        สถานะคำสั่งซื้อ :
                        <span
                          :style="`font-weight: normal; font-style: italic; color: ${statusColor(
                            item.status
                          )};`"
                          >{{ item.status }}</span
                        >
                      </div>
                    </div>
                    <div style="align-self: center">
                      <v-checkbox
                        color="green"
                        hide-details
                        v-model="selectedOrders"
                        :value="item"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </div>
      </ValidationObserver>
      <div @click="toacreatebooking" v-ripple class="addcartbtn Kanit myshadow">
        <p v-if="!saveloading">ยืนยัน</p>
        <div v-else>
          <v-progress-circular
            indeterminate
            size="35"
            color="white"
          ></v-progress-circular>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Loading from "@/components/Loading.vue";
import { VDigitalTimePicker } from "v-digital-time-picker";

export default {
  data() {
    return {
      loading: true,
      menu2: false,
      saveloading: false,
      selectedOrders: [],
      menu: false,
      timeoptions: ["13.00", "14.00", "15.00", "16.00"],
      input: {
        time: "",
        shipper_name: "",
        shipper_phoneno: "",
        remark: "",
        quantity: "",
      },
      orders: [],
    };
  },
  components: { VDigitalTimePicker, Loading },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  async mounted() {
    await this.checkTime();
    await this.getOrders();
    await this.toadealerbookingtime();
    this.loading = false;
  },
  methods: {
    toadealerbookingtime() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toadealerbookingtime",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              resolve();
            } else if (response.data.responsecode == 200) {
              vm.input.time = response.data.data[0].booking_time;
              vm.$forceUpdate();
              resolve();
            }
          });
      });
    },
    statusColor(status) {
      if (status == "จัดส่งเรียบร้อย") return "green";
      else if (status == "รอการจัดส่ง") return "orange";
      else return "red";
    },
    getOrders() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toadealerorderreadytoship",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              vm.orders = response.data.data;
            }
            resolve();
          });
      });
    },
    checkTime() {
      var vm = this;
      var format = "hh:mm:ss";

      var time = moment(),
        beforeTime = moment("00:00:00", format),
        afterTime = moment("11:00:00", format);
      return new Promise((resolve) => {
        if (!time.isBetween(beforeTime, afterTime)) {
          this.$swal
            .fire({
              text:
                "คุณสามารถเลือกได้อีกทีเวลา 0.00-11.00 ในวันพรุ่งนี้สามารถเรียกได้",
            })
            .then(async (result) => {
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
              resolve();
            });
        } else {
          resolve();
        }
      });
    },
    allowedMinutes(v) {
      return v == 0 || v == 30;
    },
    alloweddates(val) {
      return moment(val).diff(moment(), "days") >= 0;
    },
    async toacreatebooking() {
      if (!this.saveloading) {
        var vm = this;
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          this.saveloading = true;
          var orderlist = [];
          var quantity;
          if (vm.selectedOrders && vm.selectedOrders.length) {
            orderlist = this.selectedOrders.map((el) => el.order_number);
            quantity = this.selectedOrders.reduce((total, cur) => {
              var order = JSON.parse(cur.orderdetail);
              return (
                total +
                order.productlist.reduce((a, b) => {
                  return a + parseInt(b.quantity);
                }, 0)
              );
            }, 0);
          } else {
            quantity = this.input.quantity;
          }
          var data = {
            userid: this.$store.state.userid,
            apptype: this.query.apptype,
            pageid: this.query.pageid,
            booking_time: this.input.time,
            quantity: quantity,
            shipper_name: this.input.shipper_name,
            shipper_phoneno: this.input.shipper_phoneno,
            order_numberlist: orderlist,
            remark: this.input.remark,
          };
          axios
            .post(
              "https://communitybotbyzwizai.herokuapp.com/toacreatebooking",
              data,
              {
                headers: {
                  AUTHORIZATION: "Bearer xxx xxx",
                },
              }
            )
            .then(async (response) => {
              this.saveloading = false;
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              } else if (response.data.responsecode == 200) {
                await vm.$swal.fire({
                  text: "เสร็จสิ้น",
                });
                if (this.query.apptype == "line") {
                  await this.$liff.closeWindow();
                } else if (this.query.apptype == "facebook") {
                  this.$store.dispatch("messengerClose");
                }
              }
            });
        }
      }
    },
  },
  watch: {
    selectedOrders(newValue, oldValue) {
      this.input.quantity = "";
    },
  },
  filters: {
    dateFormat(e, f) {
      if (e) {
        return moment(e).format(f);
      } else return "";
    },
  },
};
</script>